import { enforce, omitWhen, test } from 'vest';

import {
  isEndpointUrl,
  withDefaults,
} from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface SihotService {
  apiEndpoint: string;
  user: string;
  password: string;
  hotelNumber: string;
  languageCodeMap: string | null;
}

const HOTEL_NUMBER = /^[1-9][0-9]*$/;
const LANGUAGE_CODE_MAP = /^\w+:[a-z]{2}( \w+:[a-z]{2})*$/;

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    apiEndpoint: '',
    user: '',
    password: '',
    hotelNumber: '',
    languageCodeMap: '',
  },
  features: {},
  cron: [],
  webhooks: [{ name: 'reservations', enabled: true }],
});

export const sihot: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig.service as unknown as SihotService;

    test(`${SERVICE}.apiEndpoint`, t('validations.required'), () => {
      enforce(service.apiEndpoint).isNotBlank();
    });

    omitWhen(!service.apiEndpoint, () => {
      test(`${SERVICE}.apiEndpoint`, t('validations.url'), () => {
        enforce(isEndpointUrl(service.apiEndpoint)).isTruthy();
      });
    });

    for (const field of ['user', 'password'] as const) {
      test(`${SERVICE}.${field}`, t('validations.required'), () => {
        enforce(service[field]).isNotBlank();
      });
    }

    test(`${SERVICE}.hotelNumber`, t('validations.required'), () => {
      enforce(service.hotelNumber).isNotBlank();
    });

    omitWhen(!service.hotelNumber, () => {
      test(`${SERVICE}.hotelNumber`, t('validations.invalid'), () => {
        enforce(service.hotelNumber).matches(HOTEL_NUMBER);
      });
    });

    omitWhen(!service.languageCodeMap, () => {
      test(`${SERVICE}.languageCodeMap`, t('validations.invalid'), () => {
        enforce(service.languageCodeMap).matches(LANGUAGE_CODE_MAP);
      });
    });
  },
};
